import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getPublishedDocuments,
  WSGetOrgUsers,
} from "../../../../configs/WebService";
import axios from "axios";
import moment from "moment";
import userStore from "../../../../zustand/userStore";
import { apiKeyHeader } from "../../../../configs/ApiKeys";

export const getDocumentsDataThunk = createAsyncThunk(
  "Organiser/getDocumentsDataThunk",
  async ({ userId, orgId }, thunkAPI) => {
    try {
      const response = await fetch(
        ` https://web1024.docmaster.in:8443/organisation/getAllDocForm/${userId}/${orgId}`,
        {
          method: "GET",
          headers: apiKeyHeader(),
          // body:JSON.stringify({ type:"asishSood"})
        },
      );
      const data = await response.json();

      if (data.result_code === 1) {
        return data.result_message;
      } else {
        alert(data.result_message);
      }

      if (!response.ok) {
        throw new Error(data?.message || "Error Fetching Offices");
      }

      console.log(data, "documents data");

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const getDocumentsData = createAsyncThunk(
  "documents/getDocumentsData",
  async ({ type, categoryIds }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        getPublishedDocuments,
        { type, categoryIds },
        { headers: apiKeyHeader() },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message,
      );
    }
  },
);
